import { lazy } from 'react';
import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

const manifest: SkillManifest = {
  key: 'provenance',
  name: 'Herkunft',
  description:
    'KI-Analyse: extrahiert brandschutzrelevante Findings pro Dokument und zeigt die Herkunft beidseitig (Dokument↔Feld).',
  category: 'ai',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_READ],
  enabledByDefault: true,
};

const ProvenancePanel = lazy(() =>
  import('./ProvenancePanel').then((m) => ({ default: m.ProvenancePanel })),
);

export const provenanceFrontendSkill: FrontendSkill = {
  manifest,
  slots: {
    'project-detail.tabs': [
      {
        key: 'provenance-panel',
        order: 45,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId + readOnly
        render: ProvenancePanel,
      },
    ],
  },
};
